import type { GetOrderOnPostBookingPageQuery } from '@eti/schema-types';

export const getAddedAncillaryBundle = (data?: GetOrderOnPostBookingPageQuery) => {
  const ancillaryBundleData = data?.orderNew?.trips?.[0]?.ancillaryBundles;

  if (!ancillaryBundleData || !ancillaryBundleData?.length) {
    return null;
  }

  return ancillaryBundleData
    .filter((ancillaryBundle) => ancillaryBundle?.selectedOption !== null)
    .map(
      (ancillaryBundle) =>
        ancillaryBundle?.options?.find(
          (option) =>
            option?.id !== undefined &&
            String(option?.id) === String(ancillaryBundle?.selectedOption),
        ),
    );
};
